import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { SessionService } from '../../services/session';
import { SharedService } from '../../services/shared.service';
import { MESSAGE } from '../../utils/messages';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
export class AuthenticationComponent implements OnInit {
  @ViewChild('authForm') form: NgForm;

  constructor(
    private authService: AuthenticationService,
    private sessionService: SessionService,
    private sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    this.sessionService.clearStorage();
  }

  onSubmit() {
    const username = this.form.value.username;
    const password = this.form.value.password;

    this.authService.login(username, password).subscribe({
      next: (res: any) => {
        this.sessionService.setAccessToken(res.accessToken);
        this.sessionService.setRefreshToken(res.refreshToken);
        this.sessionService.setAccessTokenValidUntil(res.accessTokenValidUntil);
        this.sessionService.setRefreshTokenValidUntil(res.refreshTokenValidUntil);
        this.authService.setIsLoggedIn(true);
      },
      error: error => {
        error.appCode
          ? this.sharedService.showMessage(error.appCode)
          : this.sharedService.showMessage(MESSAGE.error_login);
      },
    });
  }
}
